<template lang="pug">
.home-container(:style="{ 'text-align': lang === 'chinese' ? 'justify' : 'left' }")
  .float-box
    .head {{ lang === 'chinese' ? '关于我们' : 'About us' }}
    .body
      a.top(href="https://arkemacn.1688.com/")
        div(v-html="lang === 'chinese' ? '阿里巴巴1688' : 'Alibaba 1688'")
        img(src="https://oss.cloud.custouch.com/res/72764/icon-箭头.png")
      .bottom
        div(v-html="lang === 'chinese' ? '微信公众号' : 'More information about Product on WeChat'")
        img(src="https://oss.cloud.custouch.com/res/80403/72363c5a927acfb865da623cb6a3d70.png")
      .column
        .title {{ lang === 'chinese' ? '联系方式' : 'Contact us' }}
        div {{ lang === 'chinese' ? '孔耀' : 'Jack KONG' }}
        a(href="tel:+86 21 61476888") +86 21 61476888
        a(href="tel:+86 18521056079") +86 18521056079{{ lang === 'chinese' ? '（同微信号）' : '' }}
        a(href="mailTo:jack.kong@arkema.com") jack.kong@arkema.com
        div(v-html="lang === 'chinese' ? '上海市静安区万荣路777号<br>大宁音乐广场H座10楼' : '10th Floor, Building H, Daning Music Plaza, No.777 Wanrong Road, <br>Shanghai'")
  .top-bar
    .content
      img(src="https://oss.cloud.custouch.com/res/72772/logo1.png")
      div.lang-container(@click="lang = lang === 'chinese' ? 'english' : 'chinese'")
        span(:class="{ active: lang === 'chinese' }" ) 中文
        .bar
        span(:class="{ active: lang === 'english' }") English
  div(v-show="lang === 'english'")
    .banner-wrapper
      .wrapper
        .box
          .content
            h3 Hebei CASDA Biomaterials Co.,Ltd.
            span A major global manufacturer and supplier of sebacic acid and dimethyl sebacate.
    .content
      .panel.flex-box
        .left
          h4 Oleris<sup>®</sup> Sebacic acid
          div Product
          div Oleris<sup>®</sup> Sebacic acid is a natural C10 solid fatty acid, directly produced from castor oil. Our sebacic acid has a high quality, a secure supply chain, and a natural origin. 
        .right.bottom
          img(src="../assets/images/Sebacic-acid.png")
      .section
        h4 Identity
        .info
          .title CAS number
          .value 111-20-6
        .info
          .title Chemical name
          .value Sebacic acid
        .info
          .title Common name
          .value Decanedioic acid; 1,10-Decanedioic acid; 1,10-Decanedioic acid; 1,8-Octane dicarboxylic acid; C10H18O4; HOOC(CH2)8COOH
      .section
        h4 Properties
        .list
          div High purity
          div 100% of vegetal origin
          div Linear chain
          div Granules or powder forms
          div High reactivity to produce a wide range of esters
          div Refined grade available for enhanced performance
      .section
        h4 Major Applications
        div Oleris<sup>®</sup> Sebacic acid offers a competitve solution in many applications:
        .list
          div To produce polymers, i.e. polyamide, polyester, polyester polyol, alkyd resin, etc.
          div In industry: to produce plasticizers, lubricants, and corrosion inhibitors
          div In cosmetics: as buffering ingredient or as a chemical intermediate to produce a wide range of esters
      .section
        h4 Cosmetic applications
        div Oleris<sup>®</sup> Sebacic acid can be used directly in cosmetics formulation as a pH corrector (buffering). In this case, the main applications are skin care (mainly face/neck care), and color cosmetics.
        .flex-box
          .left
            img(src="../assets/images/femme-shampoing-95447834.jpg")
          .right
            div The sebacic acid is also widely used as a synthesis intermediate to produce sebacates esters such as DIPS or DIS (diisopropyl sebacate), DOS (diethylhexyl sebacate), DES (diethyl sebacate) and DBS (dibutyl sebacate).
            div These sebacate are used as: emollient, solvent, masking (reducing or inhibiting the basic odour of the product), film forming, hair or skin conditioning. Generally, sebacate esters are claimed to enable a good penetration, give a non-oily and silky skin feel. These esters are also recognized to be good pigment dispersant (DOS), be good sun protection factor (SPF) booster (DIPS blended), and prevent whitening in antiperspirant (DIPS).
      .section
        h4 Plastics and plasticizers applications
        div The sebacic acid (DC10), is an important bio-based building block for plastics industry.
        .flex-box
          .left
            div Oleris<sup>®</sup> Sebacic acid provides a good compromise in term of properties: better than those given by adipic acid (DC6) and very close to those allowed by dodecanedioic acid (DC12) or by azelaic acid (DC9).The most famous application of sebacic acid in the plastics world is the manufacture of polyamides (PA 6.10, PA 4.10, PA 10.10, etc). Compared to diacids with a lower carbon atom number (eg: adipic acid), the Oleris<sup>®</sup> Sebacic acid provides better flexibility, ductility, hydrophobicity, and lower melting temperature.
            div The other types of plastics (including CASE) where sebacic acid is used are co-polyamides, polyesters, co-polyesters, alkyd resins, polyester polyols, polyurethanes, etc. In addition, Oleris<sup>®</sup> Sebacic acid is also seen use as hardener in GMA powder coating.
            div Sebacates esters are environmental friendly plasticizers for vinyl polymers (namely PVC, PVDC, PVDF). Having a long linear chain, the sebacates provide good performance at low temperature environment. In addition, DBS (dibutyl sebacate) is suitable for food contact application, while DIDS (diisodecyl sebacate) is often used in low VOC PVC.
          .right
            img(src="../assets/images/chemical-plastic-granules.jpg")
      .section
        h4 Lubricant, grease and anti-corrosion applications
        div The sebacic acid (DC10), is an important bio-based building block for plastics industry.
        .flex-box
          .left
            img(src="../assets/images/Huile-vidange-153517859.jpg")
          .right
            div Oleris<sup>®</sup> Sebacic acid, and its salt derivative (di)sodium sebacate, are widely used as corrosion inhibitors. The main application of them is coolant (anti-freeze) fluids for aircraft, automotive and truck engines.
            div Sebacic acid is also a raw material to produce sebacate diesters (DOS, DBS, …), used in synthetic lubricants. Generally, diesters are used as base oils for high performance lubricants (automotive, aerospace turbines, high reliability industrial hydraulics and compressor systems).
        div.gap These diesters offer major advantages (compared to mineral oils):
        table(border="0")
          tr.list
            td High viscosity index
            td Low temperature fluidity
          tr.list
            td Low pour points
            td Low volatility
          tr.list
            td High flash points
            td Low peroxide value
          tr.list
            td Good additive response
            td High thermal stability
          tr.list
            td Overall excellent lubricity
            td Oxidation resistance
          tr.list
            td Low coking characteristics
            td.not
        div.gap Moreover, sebacates have enhanced viscosity and excellent lubricity when compared with adipates.
        div Oleris<sup>®</sup> Sebacic acid is also seen use as thickener in complexed greases formulations.
      .section
        h4 Geographic availability
        p.gap-left Worldwide
      .section
        h4 Markets
        dl.list-bar.gap-left
          dt Adhesives
          dt Automotive and aerospace
            dd Coolant
            dd Grease
          dt Lubricant
          dt Paints and coatings
            dd Coating resin
            dd Hardener
          dt Plastics and additives
            dd Engineering plastics
            dd Bioplastics
            dd Plasticizers
      .section.icp-wrapper
        a.icp(href="https://beian.miit.gov.cn") 冀ICP备05019581号-1
  div(v-show="lang === 'chinese'")
    .banner-wrapper
      .wrapper
        .box
          .content
            h3 河北凯徳生物材料<br>有限公司
            span 全球癸二酸和癸二酸二甲酯的主要生产供应商
    .content
      .panel.flex-box
        .left
          h4 Oleris<sup>®</sup> 癸二酸
          div Oleris<sup>®</sup> 癸二酸是来自于蓖麻油的功能型脂肪酸。我们的癸二酸产品是生物来源，纯度高、供应稳定。
        .right.bottom
          img(src="../assets/images/Sebacic-acid.png")
      .section
        h4 特性
        .info
          .title CAS号
          .value 111-20-6
        .info
          .title 化学名
          .value 癸二酸
        .info
          .title 常用名
          .value 皮脂酸，十碳二酸
      .section
        h4 性能特点
        .list
          div 高纯度直链脂肪酸
          div 100% 植物来源
          div 颗粒或粉末形态可选
          div 高反应活性，可用于生产各类聚合物和酯
          div 精制级别专为高端应用开发，增强产品性能
      .section
        h4 应用领域
        div Oleris<sup>®</sup> 癸二酸广泛用于：
        .list
          div 聚合物，如聚酰胺（尼龙）、聚酯树脂、聚酯多元醇、醇酸树脂等。
          div 化学工业中间体，用于生产增塑剂、润滑油和缓蚀剂。
          div 化妆品行业，作为缓冲成分，或作为合成各种酯类的原料。
      .section
        h4 化妆品应用
        div Oleris<sup>®</sup> 癸二酸可直接作为pH缓冲成分用于化妆品配方中。这些配方用于护肤和色彩产品。
        .flex-box
          .left
            img(src="../assets/images/femme-shampoing-95447834.jpg")
          .right
            div 癸二酸还广泛作为合成中间体用于生产癸二酸酯，比如DIPS/DIS癸二酸二异丙酯，DOS癸二酸二辛酯，DES癸二酸二乙酯，和DBS癸二酸二丁酯。
            div 这些癸二酸酯用作润肤剂、溶剂、成膜剂和护发成分。据报道，癸二酸酯类有较好的穿透性，给皮肤丝般的感觉，而没有油腻感。DOS被认为是很好的色素分散剂，DIPS混配可提高配方的防晒系数，也能减少止汗剂的发白效应。
      .section
        h4 塑料和增塑剂
        div 癸二酸也是塑料和增塑剂的原料，是重要的生物基功能性单体。
        .flex-box
          .left
            div Oleris<sup>®</sup> 癸二酸（DC10）作为单体，综合性能优于己二酸（DC6），和十二碳二酸（DC12）和壬二酸（DC9）非常接近。
            div 在塑料行业，癸二酸最大的应用是生产尼龙，比如尼龙610、410、1010等。同碳数更低的二酸（己二酸或丁二酸）比较，癸二酸可提供更好的柔韧性和延展性，降低吸水率和熔点。
            div 癸二酸的其他用途有共聚酰胺、聚酯、共聚酯、醇酸树脂、聚酯多元醇、聚氨酯等等。此外，癸二酸可在GMA型粉末涂料配方中做固化剂。
            div 癸二酸酯类也是环境友好的增塑剂，可用于聚氯乙烯PVC、聚偏氯乙烯PVDC、聚偏氟乙烯PVDF等。由于它们的长链，癸二酸酯在低温环境中有优异的增塑性能。此外，DBS癸二酸二丁酯适用于食品接触用途，而DIDS癸二酸二异癸酯常用于低VOC的PVC配方。
          .right
            img(src="../assets/images/chemical-plastic-granules.jpg")
      .section
        h4 润滑油、润滑脂和缓蚀剂
        div Oleris<sup>®</sup> 癸二酸和癸二酸二钠盐广泛用作缓释剂，主要用于飞机、汽车、卡车发动机防冻液（冷却液）中。
        .flex-box
          .left
            img(src="../assets/images/Huile-vidange-153517859.jpg")
          .right
            div 癸二酸酯类也用于合成润滑油。
            div DOS癸二酸二辛酯和DBS癸二酸二丁酯可用作高性能润滑油的基础油。
        div.gap 同矿物油相比，酯类基础油有如下优点：
        table.table(border="0")
          tr.list
            td 粘度系数高  
            td 低温流动性好
          tr.list
            td 倾点低 
            td 挥发性低
          tr.list
            td 闪点高
            td 过氧化物值低
          tr.list
            td 对添加剂友好 
            td 高热稳定性
          tr.list
            td 整体润滑性能好   
            td 抗氧化 
          tr.list
            td 积碳少
            td.not
        div.gap 与己二酸酯相比，癸二酸酯有更好的粘度系数和润滑性能。
        div Oleris<sup>®</sup> 癸二酸也作为增稠剂，用于复合锂基润滑脂。
      .section
        h4 销售区域
        p.gap-left 全球
      .section
        h4 市场
        dl.list-bar.gap-left
          dt 胶黏剂
          dt 涂料
            dd 涂料树脂
            dd 固化剂
          dt 汽车和航空
            dd 冷却液
            dd 润滑脂
            dd 润滑油
          dt 塑料和添加剂
            dd 工程塑料
            dd 生物塑料
            dd 增塑剂
      .section.icp-wrapper
        a.icp(href="https://beian.miit.gov.cn") 冀ICP备05019581号-1

</template>

<script>
// @ is an alias to /src
export default {
  name: 'home',
  data() {
    return {
      lang: 'chinese'
    }
  }
}
</script>
<style lang="scss" scoped>
$themeColor: #28285F;
.home-container {
  position: relative;
  .text-center {
    text-align: center;
    font-weight: bold;
    font-size: 1.1em;
  }
  .indent {
    text-indent: 1rem;
  }
  .float-box {
    position: fixed;
    right: 1rem;
    top: 40%;
    width: 7rem;
    z-index: 1;

    .head {
      background: url("https://oss.cloud.custouch.com/res/80410/凯德_关于我们_banner.jpg") no-repeat center/cover;
      color: #fff;
      padding: 0.25rem;
    }
    .body {
      padding: 0.5rem 0.2rem;
      background: #fff;
      box-shadow: 0px 3px 8px 1px rgba(186, 186, 186, 0.74);
      color: $themeColor;
      a {
        color: $themeColor;
      }
      .top > img {
        width: 1rem;
        object-fit: contain;
      }
      .bottom > img {
        width: 2rem;
        object-fit: contain;
      }
      .top,
      .bottom,
      .column {
        display: flex;
        border-bottom: 1px solid #e3e3e3;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 0.5rem;
        margin-bottom: 0.5rem;
      }
      .column {
        word-break: break-all;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .title {
          font-size: 1.1em;
          margin-bottom: 0.3rem;
        }
      }
    }
  }
  .top-bar {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 2.5rem;
    z-index: 1;
    background: #fff;
    box-shadow: 0 5px 8px 0 rgba(230, 230, 230, 0.5);
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      max-width: 865px;
      margin: 0 auto;
      > img {
        height: 1.8rem;
        object-fit: contain;
      }
      .lang-container {
        cursor: pointer;
        display: flex;
        align-items: center;
        .bar {
          display: inline-block;
          width: 1px;
          height: 100%;
          margin: 0 0.2rem;
          height: 0.4rem;
          background: #000;
        }
        .active {
          color: #55BE9B;
        }
      }
    }
  }
  .banner-wrapper {
    padding: 0 0.3rem;
    background: $themeColor;
    position: relative;
    margin-top: 2.5rem;
    .wrapper {
      background: url("https://oss.cloud.custouch.com/res/80407/凯德网站banner.jpg")
        no-repeat center/cover;
      width: 100%;
      height: 11rem;
      .box {
        max-width: 865px;
        margin: 0 auto;
        position: relative;
        height: 100%;
      }
      .content {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        margin: 0 auto;
        background: rgba(255, 255, 255, 0.8);
        padding: 1.25rem 1rem;
        width: 13.2rem;
        font-weight: bold;
        > h3 {
          font-size: 1rem;
          margin-bottom: 0.75rem;
        }
        > span {
          font-size: 0.5rem;
        }
      }
    }
  }
  .content {
    max-width: 865px;
    margin: 1rem auto 5rem;
    img {
      padding-top: 9px;
    }
    h4 {
      color: $themeColor;
      font-size: 1rem;
      padding-bottom: 5px;
      margin-bottom: 25px;
      border-bottom: 1px solid #b7b7b7;
      font-weight: normal;
    }
    .bottom {
      align-self: flex-end;
      font-size: 0;
    }
    .panel {
      border: 2px solid #f3f3f3;
      padding: 0.5rem;
      h4 {
        border: 0;
        margin: 0;
      }
    }
    .flex-box {
      display: flex;
      margin-top: 0.5rem;
      img {
        width: 100%;
      }
      .left,
      .right {
        > div:not(:last-child) {
          margin-bottom: 0.4rem;
        }
      }
      .left {
        margin-right: 0.5rem;
        flex: 1;
      }
      .right {
        flex: 1;
      }
    }
    .icp-wrapper {
      background: #000;
      line-height: 50px;
      .icp {
        display: block;
        text-align: center;
        font-size: 0.8em;
        color: #f5f5f5;
      }
    }
    .section {
      margin-top: 0.5rem;
      .info {
        display: flex;
        .title {
          flex: 2;
        }
        .value {
          flex: 8;
        }
      }
      .info:not(:last-child) {
        margin-bottom: 0.5rem;
      }
      .list {
        padding-left: 1rem;
        div {
          display: flex;
          align-items: flex-start;
        }
        .not::before {
          content: "";
        }
        div,
        td {
          &::before {
            content: "●";
            text-align: center;
            color: #55BE9B;
            margin-right: 0.2rem;
          }
        }
      }
      .gap {
        margin-top: 0.3rem;
      }

      .gap-left {
        margin-left: 1rem;
      }
      table {
        width: 100%;
        td {
          padding: 0.3rem 0;
          padding-left: 1rem;
        }
        tr {
          background-color: #f8f8f8;
        }
      }
      .table {
        tr:nth-child(2n + 1) {
          background-color: #f8f8f8;
        }
        tr {
          background-color: #fff;
        }
        tr:hover {
          background-color: #f8f8f8;
        }
      }
      .list-bar {
        display: flex;
        flex-direction: column;
        height: 6.5rem;
        flex-wrap: wrap;
        dt {
          //   display: inline-block;
          width: 50%;
          margin-bottom: 0.5rem;
        }
        dd {
          background: url("../assets/images/filter-indent-clair.png") 0 0
            no-repeat;
          padding-left: 0.5rem;
          margin-left: 0.5rem;
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .content {
    padding: 0 0.5rem;
  }
  .flex-box {
    flex-direction: column;
  }
}
</style>
